export const notificationHistoryTheme = {
  readIconColor: 'palette.neutral.10',
  unreadIconColor: 'palette.tertiary.80',
};
